import moment from 'moment'

export function format (time) {
    return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
}

//获取当前日期yy-mm-dd
//date 为时间对象
export function getDayStr (date) {
    let year = "";
    let month = "";
    let day = "";
    let now = date;
    year = "" + now.getFullYear();
    if ((now.getMonth() + 1) < 10) {
        month = "0" + (now.getMonth() + 1);
    } else {
        month = "" + (now.getMonth() + 1);
    }
    if ((now.getDate()) < 10) {
        day = "0" + (now.getDate());
    } else {
        day = "" + (now.getDate());
    }
    return year + "-" + month + "-" + day + " 00:00:00";
}
const timeZone = -(new Date().getTimezoneOffset() / 60);
/**
 * 
 */
export function getToDay (diff) {
    let startStop = new Array();
    // 一天的毫秒数
    let millisecond = 1000 * 60 * 60 * 24;
    // 获取当前MT4时间
    let currentDate = getCurrentMT4Time(diff)
    // 获取明天MT4时间
    let tomorrow = new Date(currentDate.getTime() + millisecond);

    startStop.push(getDayStr(currentDate));
    startStop.push(getDayStr(tomorrow));
    return startStop;
}

export function getCurrentMT4Time (diff) {
    // 获取当前时间 
    const date = new Date().getTime();
    // 获取当前MT4时间
    return new Date(date - (timeZone - diff) * 36e5);
}

/** 
 * 获得相对当前周AddWeekCount个周的起止日期 
 * AddWeekCount为0代表当前周   为-1代表上一个周   为1代表下一个周以此类推
 * **/
export function getWeekStartAndEnd (AddWeekCount, diff) {
    //起止日期数组   
    let startStop = new Array();
    //一天的毫秒数   
    let millisecond = 1000 * 60 * 60 * 24;
    //获取当前时间   
    let currentDate = new Date();
    //相对于当前日期AddWeekCount个周的日期
    currentDate = new Date(currentDate.getTime() + (millisecond * 7 * AddWeekCount) - (timeZone - diff) * 36e5);
    //返回date是一周中的某一天
    let week = currentDate.getDay();
    //减去的天数   
    let minusDay = week != 0 ? week : 7;
    //获得当前周的第一天   
    let currentWeekFirstDay = new Date(currentDate.getTime() - (millisecond * minusDay));
    //获得下周的第一天
    let currentWeekLastDay = new Date(currentWeekFirstDay.getTime() + (millisecond * 7));
    //添加至数组   
    startStop.push(getDayStr(currentWeekFirstDay));
    startStop.push(getDayStr(currentWeekLastDay));

    return startStop;
}
/** 
 * 获得相对当月AddMonthCount个月的起止日期 
 * AddMonthCount为0 代表当月 为-1代表上一个月  为1代表下一个月 以此类推
 * ***/
export function getMonthStartAndEnd (AddMonthCount, diff) {
    //起止日期数组   
    let startStop = new Array();
    //获取当前时间   
    let currentDate = new Date();
    let month = currentDate.getMonth() + AddMonthCount;
    if (month < 0) {
        let n = parseInt((-month) / 12);
        month += n * 12;
        currentDate.setFullYear(currentDate.getFullYear() - n);
    }
    currentDate = new Date(currentDate.setMonth(month));
    currentDate = new Date(currentDate.getTime() - (timeZone - diff) * 36e5);
    //获得当前月份0-11   
    let currentMonth = currentDate.getMonth();
    //获得当前年份4位年   
    let currentYear = currentDate.getFullYear();
    //获得本月的第一天   
    let currentMonthFirstDay = new Date(currentYear, currentMonth, 1);
    //获得下个月的第一天   
    let currentMonthLastDay = new Date(currentYear, currentMonth + 1, 1);
    //添加至数组   
    startStop.push(getDayStr(currentMonthFirstDay));
    startStop.push(getDayStr(currentMonthLastDay));
    //返回   
    return startStop;
}

export function disableDate (time) {
    return time.getTime() > new Date()
}

export function onPick (property) {
    const minDate = property.minDate
    if (!property.maxDate && property.minDate) {
        const minAfter = this.$moment(minDate).add(1, 'month')
        const now = this.$moment()
        const max = now.isAfter(minAfter) ? minAfter : now
        const minBefore = this.$moment(minDate).subtract(1, 'month')
        this.disabledDate = time => {
            return time.getTime() > new Date(max) || time.getTime() < new Date(minBefore)
        }
    }
}
/**
 * el-date-picker控件只可选周一和周五
 * 如果目前时间还没到周六，最多只能选上周一和周五
 * @param {*} time 
 * @returns 
 */
export function enableMondayAndFriday (time) {
    const now = new Date()
    const weekday = now.getDay() + 1
    const seconds = weekday > 6 ? 1 : (weekday + 1) * 24 * 36e5
    now.setTime(now.getTime() - seconds)
    return time.getTime() > now || [0, 2, 3, 4, 6].includes(time.getDay())
}

/**
 * el-date-picker控件只可选周一和周五的onPick函数，限制第二选择只能选择当前选择周的周一或周五
 * @param {*} property 
 */
export function enableMondayAndFridayOnPick (property) {
    const minDate = property.minDate
    if (!property.maxDate && minDate) {
        const isMonday = minDate.getDay() === 1
        const difference = isMonday ? 4 : -4
        const required = this.$moment(minDate).add(difference, 'd')
        const max = isMonday ? new Date(required) : minDate
        const min = isMonday ? minDate : new Date(required)
        this.disabledDate = function (time) {
            return time.getTime() < min || time.getTime() > max || (time.getTime() > min && time.getTime() < max)
        }
    }
}

/**
 * el-date-picker控件只能选择每月1号，最多只能选上月1号
 * @param {*} time 
 * @returns 
 */
export function enableFirstAndLastDayOfMonth (time) {
    const now = new Date()
    const monthDay = now.getDate()
    const seconds = monthDay * 24 * 36e5
    now.setTime(now.getTime() - seconds)
    return time.getTime() > now || time.getDate() !== 1
}

/**
 * el-date-picker控件只能选每月1号的onPick函数，限制第二选择只能选当前选择月的月头和月尾
 * @param {*} property 
 */
export function enableFirstAndLastDayOfMonthOnPick (property) {
    const minDate = property.minDate
    if (!property.maxDate && minDate) {
        const daysOneMonth = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 0).getDate()
        const required = this.$moment(minDate).add(daysOneMonth - 1, 'd')
        const max = new Date(required)
        this.disabledDate = function (time) {
            return time.getTime() < minDate || time.getTime() > max || (time.getTime() > minDate && time.getTime() < max)
        }
    }
}

/**
 * el-date-picker控件只能选择截止到今日且除周六日的日期
 * @param {*} time 
 * @returns 
 */
export function enableUntilToday (time) {
    const now = new Date()
    now.setTime(now.getTime() - 24 * 36e5)
    return time.getTime() > now || [0, 6].includes(time.getDay())
}

/**
 * el-date-picker控件只能选择截止到今日且除周六日的日期的onPick函数，限制第二选择和第一选择一样
 * @param {*} property 
 */
export function enableUntilTodayOnPick (property) {
    const minDate = property.minDate
    if (!property.maxDate && minDate) {
        this.disabledDate = function (time) {
            return time.getTime() < minDate || time.getTime() > minDate
        }
    }
}

export function makeSound () {
    window.AudioContext = window.AudioContext || window.webkitAudioContext
    const audioCtx = new AudioContext()
    const oscillator = audioCtx.createOscillator()
    const gainNode = audioCtx.createGain()
    oscillator.connect(gainNode)
    gainNode.connect(audioCtx.destination)
    gainNode.gain.value = 1
    oscillator.type = 'sine'
    oscillator.frequency.value = 1000
    oscillator.start(audioCtx.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 3)
    oscillator.stop(audioCtx.currentTime + 3)
}


// WEBPACK FOOTER //
// ./src/common/js/util.js